import React from 'react';
import withView from './docAutomation/withView';
import ReferenceBreakupRow from './ReferenceBreakupRow';
import FormTitle from '../../library/form/components/FormTitle'
import SarasTrans from '../../library/notifications/SarasTrans';
import FormButton from '../../library/form/components/FormActionButton2';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../library/layout/Index";

const ReferenceBreakup = (props) => {
    const { formObject, viewData } = props;
    // const [showPopup, setShowPopup] = React.useState(false);

    if (!viewData)
        return (null)

    // const showModel = () => {
    //     setShowPopup(true);
    // }

    // const hideModel = () => {
    //     setShowPopup(false);
    // }

    return (
        <>
            {/* <div onClick={showModel} >
                <SarasTrans value="Serial Number List : " />
                <FormROValue format="#" formObject={formObject} rowKey="" headerKey="refBreakup" action={{ paramName: "totalCount" }} />
            </div> */}

            {/* <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={showPopup} onPopupClose={hideModel}
                action={{ formActions: { forClose: "Close" }, refreshMode:"self" }}
                formStyle={{ width: '700px' }}
                contentStyle={{ height: '380px' }}
                formTitle={<FormTitle formObject={formObject} value='Check List Passengers' />}
                formObject={formObject} > */}
                <UiView>
                    <UiViewHeading>
                        <UiTitle>
                            <span>
                                <FormTitle formObject={formObject} value='Breakup Details' />
                            </span>
                        </UiTitle>
                        <UiAction>
                            <FormButton formObject={formObject} id="newAddButton" ksc="p" rowKey=""
                                action={{ actionId: "new",  actionParam: {}, containerKey: "row" }}
                                className="uiActionButton" text={<SarasTrans value="Add Record" />}></FormButton>
                        </UiAction>
                    </UiViewHeading>
                    <UiViewContent>
                        <ul className="uiListTable">
                            <li className="uiSearchHeading">
                                <ul>
                                    <li className="uiColumnCenter uiColumn50"><SarasTrans value="Sr No" /></li>
                                    <li className="uiColumnCenter uiColumn200"><SarasTrans value="Serial Number" /></li>
                                    <li className="uiColumnCenter uiColumn70"><SarasTrans value="Action" /></li>
                                </ul>
                            </li>
                            {
                                Object.values(viewData).map((row, index) => (
                                    <ReferenceBreakupRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index} />
                                ))
                            }
                        </ul>
                    </UiViewContent>
                </UiView>
            {/* </FormDialog> */}
        </>
    )

}

export default withView(ReferenceBreakup, "refBreakup", "refBreakup")